
  // ═══════════════════════════════════════════════════════════════
  // VARIABLES À CUSTOMISER POUR CHAQUE PAGE
  // ═══════════════════════════════════════════════════════════════

    const modelDefs = [

    { // puits_1
      url:        "./assets/massou/models/puit_tour_ipad_30000.ksplat",
      posX: 0,        posY: 0,        posZ: 0,
      rotXDeg: 0,     rotYDeg: 0,     rotZDeg: 0,
      scale: 1,
      localOffX: 0,   localOffY: 0,   localOffZ: 0,
    },
  ];// ── Reconstruction dynamique des arrays attendus par spark_viewer_v2.js ──
  const models       = modelDefs.map(m => m.url);
  const modelsAmount = models.length;

  const config_models = {
    lieuCible:    null,
    meshURL:      null,
    planURL:      './assets/chomo/plans/plan_topo_chomo.svg',
    curvesURL:   './assets/chomo/plans/chomo_topo_sans_plan3.svg',
    modelsAmount,
    modelURL:     models,

    camPosX: 3.2,   camPosY: 7.3,    camPosZ: 4.8,
    camRotX: -0.6,    camRotY: 0.2,     camRotZ: 0.1,
    camTargetX: 0.7, camTargetY: 2, camTargetZ: -2.6,
    camMinDistance: 0.1,
    camMaxDistance: 1000,
    camDampingFactor: 1,

    bgColor: "#000000",

    modelPosX:      modelDefs.map(m => m.posX),
    modelPosY:      modelDefs.map(m => m.posY),
    modelPosZ:      modelDefs.map(m => m.posZ),
    modelRotXDeg:   modelDefs.map(m => m.rotXDeg),
    modelRotYDeg:   modelDefs.map(m => m.rotYDeg),
    modelRotZDeg:   modelDefs.map(m => m.rotZDeg),
    modelScale:     modelDefs.map(m => m.scale),
    modelLocalOffX: modelDefs.map(m => m.localOffX),
    modelLocalOffY: modelDefs.map(m => m.localOffY),
    modelLocalOffZ: modelDefs.map(m => m.localOffZ),
  };

  // ── Plan ────────────────────────────────────────────────────
  const config_plan = {
    showPlan:           false,
    planMeshInFront:    false,
    planScale:          1,
    planMaterialOpacity: 1.0,
    planPosX:  -0.917999999999992,
    planPosY:  0,
    planPosZ:  34.2102,
    planRotX:  -90,
    planRotY:  0,
    planRotZ:  96.0306
  };

  // ── Courbes (Topographic Curves) ─────────────────────────
  const config_curves = {
    showCurves: false,
    elevation_step: 6.2,        // Vertical spacing between each contour line (Three.js units)
    curves_scale: 0.047551,
    curvesWidth: 2,
    curvesPosX:   -18.1428,
    curvesPosY:   3.8,
    curvesPosZ:   127.5202,
    curvesRotX:   91.0408,
    curvesRotY:   0,
    curvesRotZ:  -96.0306

  };

  // ── Interface ──────────────────────────────────────────────────
const config_interface = {
  showInterface: false,
  showCross: true
};
  // ═══════════════════════════════════════════════════════════════

  import { initViewer } from './spark_viewer_v2.js';
  initViewer({ ...config_models, ...config_plan, ...config_curves, ...config_interface });
